import axiosInstance from "./../helper/axiosIntanceApiZalo";

import axios from './../helper/axiosIntance';
import { normalizeStringInObject } from "../utils/normalize";
function getFormData(object) {
    const formData = new FormData();
    if (object) {
        Object.keys(object).forEach(key => formData.append(key, object[key]));
    }
    return formData;
}

const add = (params) => {
    return axios.post('/ticket/api/add', normalizeStringInObject(params));
}
const view = (params) => {
    if (params.exportTicket) {
        return axios.post('/ticket/api/view', normalizeStringInObject(params), { responseType: 'blob' });
    }
    return axios.post('/ticket/api/view', normalizeStringInObject(params));
};
const edit = (params) => {
    return axios.post(`/ticket/api/edit`, getFormData(normalizeStringInObject(params)));
};
const delete_force = (params) => {
    return axios.post(`/ticket/api/delete`, getFormData(normalizeStringInObject(params)));
};
const viewAllFieldTicket = (params) => {
    return axios.post(`/ticket/api/getFieldTicket`, getFormData(normalizeStringInObject(params)));
};
const add_field_ticket = (params) => {
    return axios.post(`/ticket/api/addFieldTicket`, getFormData(normalizeStringInObject(params)));
}
const report_ticket = (params) => {
    return axios.post(`/ticket/api/reportTicket2`, normalizeStringInObject(params));
}
const complete_ticket = (params) => {
    return axios.post(`/ticket/api/completeTicket`, getFormData(normalizeStringInObject(params)));
}
const export_ticket = (params) => {
    return axios.post(`/ticket/api/exportTicket`, getFormData(normalizeStringInObject(params)));
}

const detail_ticket = (params) => {
    return axios.post(`/ticket/api/detailTicket`, normalizeStringInObject(params));
}
const get_field_ticket = (params) => {
    return axios.post(`/ticket/api/get_field_ticket`, normalizeStringInObject(params));
}
const list_project_type = (params) => {
    return axios.post(`/ticket/api/list_project_type`, normalizeStringInObject(params));
}
const add_project_type = (params)=>{
    return axios.post(`/ticket/api/add_project_type`, normalizeStringInObject(params));
}
const edit_project_type = (params)=>{
    return axios.post(`/ticket/api/edit_project_type`, normalizeStringInObject(params));
}
const remove_project_type = (params) => {
    return axios.post(`/ticket/api/remove_project_type`, normalizeStringInObject(params));
}
const updateFieldTicket = (params) => {
    return axios.post(`/ticket/api/editFieldTicket`, normalizeStringInObject(params));
}
const send_comment = (params)=>{
    return axios.post('ticket/api/send_comment',normalizeStringInObject(params))
}
const comments = (params)=>{
    return axios.post('ticket/api/comments',normalizeStringInObject(params))
}
const edit_comment = (params)=>{
    return axios.post('ticket/api/edit_comment',normalizeStringInObject(params))
}
const delete_comment = (params)=>{
    return axios.post('ticket/api/delete_comment',normalizeStringInObject(params))
}

export default {
   
    add,
    view,
    edit,
    delete_force,
    edit_project_type,
    viewAllFieldTicket,
    add_field_ticket,
    comments,
    send_comment,
    report_ticket,
    complete_ticket,
    export_ticket,
    detail_ticket,
    get_field_ticket,
    add_project_type,
    list_project_type,
    updateFieldTicket,
    remove_project_type,
    edit_comment,
    delete_comment
}
